import { ArrowRight, Zap, Percent, Clock, ShieldCheck } from "lucide-react";
import { useLoans } from "../../components/loans/LoansContext";
import { Breadcrumb, PageTitle, LenderLogo } from "../../components/loans/LoansUi";
import { RateText, useSeo } from "../LoansLanding";
import { fmtLakh } from "../../lib/loanStats";
import ShareButton from "../../components/ShareButton";

const PERKS = [{ icon: Zap, label: "Multiple Lenders" }, { icon: Percent, label: "Competitive Rates" }, { icon: Clock, label: "Quick Approval" }];

function LenderCard({ p, i }) {
  const { apply } = useLoans();
  return (
    <div data-testid={`le-lender-card-${p.id}`} className="bg-white rounded-3xl border border-slate-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-[box-shadow,transform] p-6 flex flex-col le-rise" style={{ animationDelay: `${i * 60}ms` }}>
      <div className="flex items-center gap-4 pb-5 border-b border-slate-100">
        <LenderLogo p={p} />
        <div className="min-w-0">
          <div className="text-lg font-bold truncate">{p.provider}</div>
          <div className="text-[#4B5B7C]">Personal Loan</div>
        </div>
      </div>
      <div className="grid grid-cols-2 divide-x divide-slate-200 py-5">
        <div className="pr-3"><div className="text-sm text-[#4B5B7C]">Interest from</div><div className="mt-1"><RateText rate={p.interest_rate} /></div></div>
        <div className="pl-5"><div className="text-sm text-[#4B5B7C]">Loan up to</div><div className="mt-1 text-xl font-extrabold">{fmtLakh(p.loan_max)}</div></div>
      </div>
      {p.cashback_rate && <div className="-mt-2 mb-4 text-xs font-semibold text-[#0A5BFF]">{p.cashback_rate}</div>}
      <button data-testid={`le-lender-apply-${p.id}`} onClick={() => apply(p)}
        className="mt-auto h-12 rounded-full border-2 border-[#10B981]/60 text-[#0FA37F] font-semibold inline-flex items-center justify-center gap-2 hover:bg-[#10B981] hover:text-white transition-colors">
        Apply Now <ArrowRight className="w-4 h-4" />
      </button>
      <div className="mt-2"><ShareButton product={p} /></div>
    </div>
  );
}

export default function LoansLenders() {
  useSeo("Our Lenders · loanexpress", "Trusted banks and NBFCs offering personal loans with competitive rates and quick approval.");
  const { products, loaded } = useLoans();
  return (
    <section className="max-w-7xl mx-auto px-5 md:px-10 pt-10 pb-20">
      <Breadcrumb items={[{ label: "Lenders" }]} />
      <div className="mt-10 grid lg:grid-cols-[1.3fr_1fr] gap-10 items-center">
        <PageTitle plain="Our" accent="Lenders" sub="Trusted banks and NBFCs offering personal loans with competitive rates and quick approval." />
        <div className="grid grid-cols-3 divide-x divide-slate-200">
          {PERKS.map((k) => (
            <div key={k.label} className="flex flex-col items-center text-center gap-3 px-2">
              <k.icon className="w-9 h-9 text-[#10A37F]" strokeWidth={1.6} />
              <div className="font-medium max-w-[7rem]">{k.label}</div>
            </div>
          ))}
        </div>
      </div>
      <div data-testid="le-lenders-grid" className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map((p, i) => <LenderCard key={p.id} p={p} i={i} />)}
      </div>
      {loaded && !products.length && <div className="mt-12 rounded-2xl border border-dashed border-slate-200 p-10 text-center text-[#4B5B7C]">No lenders live yet. Add loan products in Admin → Products.</div>}
      <div className="mt-14 rounded-3xl bg-gradient-to-r from-[#EAF6FB] to-[#ECFAF4] border border-slate-100 p-8 flex items-center gap-8">
        <ShieldCheck className="w-14 h-14 text-[#10A37F] shrink-0" strokeWidth={1.6} />
        <div className="border-l border-slate-300 pl-8">
          <div data-testid="le-lenders-trust" className="text-2xl font-extrabold">{products.length || ""} Trusted Lending Partners</div>
          <div className="mt-1 text-[#4B5B7C]">Compare offers, choose the best rate and apply in minutes.</div>
        </div>
      </div>
    </section>
  );
}
